import { BaseUrl } from './ApiUrl'
import AXIOS_SERVICE from '../utils/AxiosUtil'

const DashboardService = () => {}

DashboardService.GetDashboard = async()=> {  
  return await AXIOS_SERVICE('get', `${BaseUrl}/dashboard/`, {})
}
DashboardService.GetDashboardSla = async()=> {  
  return await AXIOS_SERVICE('get', `${BaseUrl}/dashboard/sla`, {})
}




 export default DashboardService